export default __webpack_public_path__ + "a45a6fc4aa3efd42d73b74f2621e5a0a.png";